import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import i18n from 'i18n-js';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { fontOP } from '@styles/fonts';
import { scaleOP } from '@components/frame';

interface OperatorPanelLoadingScreenProps {
  C: ColorFunction;
  text?: string;
}

const OperatorPanelLoadingScreen: React.FC<OperatorPanelLoadingScreenProps> = ({ C, text }) => {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Background/Light/Panel [mobile]'),
        paddingHorizontal: scaleOP(18),
        paddingVertical: scaleOP(18),
      }}
    >
      <ActivityIndicator size="large" color={C('Label/Light/Primary')} />
      <Text
        style={[
          fontOP['Subhead 2'],
          {
            color: C('Label/Light/Secondary'),
            marginTop: scaleOP(12),
            textAlign: 'center',
          },
        ]}
      >
        {text || i18n.t('Loading')}...
      </Text>
    </View>
  );
};

export default ColorWrapper(OperatorPanelLoadingScreen);
